import { useAuth } from "@/AuthProvider";
import LogisticInquiryForm from "@/components/inquiry/LogisticInquiryForm";
import SubHeader from "@/components/SubHeader";
import { privateRoutePaths } from "@/routes/private.route.config";
import { buildPath, getPrefix } from "@/utils/common";

const LogisticInquiryFormPage = () => {

    const { user } = useAuth();

    return (<div className="data-table-main">
                <SubHeader
                    layer1="Logistic Inquiries"
                    layer2="List"
                    layer3="Add"
                    pageName="Add Inquiry"
                    clickable={{
                    layer1: `/${getPrefix(user)}${buildPath(privateRoutePaths.LOGISTIC_INQUIRIES, { fordate: "" })}`,
                    layer2: "",
                    layer3: "",
                    }}
                />
                <div className="send-receive-inquiry">
                    <div className="p-0 border bg-white rounded card-shadow mt-3 send-receive-table">
                        <div className="px-2 py-2">
                            <LogisticInquiryForm />
                        </div>
                        
                    </div>
                </div>
            </div>
    )
}

export default LogisticInquiryFormPage;